import { USER_TYPE } from 'API';
import { decodeJwtPayload } from './decodeJwtPayload';
import { getCurrentAuthToken } from './getCurrentAuthToken';

export const getIsLawyerAndUser = () => {
  const token = getCurrentAuthToken();

  if (token) {
    const decodedToken = decodeJwtPayload(token);
    return (
      decodedToken?.userRanks?.findIndex((r: string) => r === USER_TYPE.Representative) > -1 &&
      decodedToken?.userRanks?.findIndex((r: string) => r === USER_TYPE.ShikumUser) > -1
    );
  } else return false;
};

export const getIsLawyer = () => {
  const token = getCurrentAuthToken();

  if (token) {
    const decodedToken = decodeJwtPayload(token);
    return decodedToken?.userRanks?.findIndex((r: string) => r === USER_TYPE.Representative) > -1;
  } else return false;
};
